import { useParams } from 'react-router-dom';

import TicketDetailContent from '../components/TicketDetailContent';

export default function DetalleTicketPage() {
  const { ticketId } = useParams<{ ticketId: string }>();
  return <TicketDetailContent ticketId={ticketId!} />;
}
